<template>
  <div >
    <BannerMain v-if="boxLayout"></BannerMain>
    <TopNavbar/>
    <Snackbar />
    <div id="progress-bar"></div>
    <router-view v-slot="{ Component, route }">
      <v-fade-transition hide-on-leave mode="out-in">
        <component :is="Component" :key="route.name"  />
      </v-fade-transition>
    </router-view>
    <CLNewFooter></CLNewFooter>
  </div>
</template>

<script>
import NProgress from "nprogress";
import "nprogress/nprogress.css";

NProgress.configure({
  showSpinner: false,
  trickleSpeed: 200,
});
// import TopNavbar from "@/layouts/TopNavbar";
// import CLFooter from "@/layouts/CLFooter.vue"
import TopNavbar from "@/layouts/TopNavbar.vue";
import BannerMain from "@/components/header-banner/bannerMain.vue";
import CLNewFooter from '@/layouts/CLNewFooter.vue'
import Snackbar from '@/components/base/Snackbar.vue'
export default {
  name: 'App',
  components: {
    Snackbar,
    CLNewFooter,
    BannerMain,
    TopNavbar,
    // TopNavbar,
    // CLFooter,
  },
  data: () => ({
    //
  }),
  created () {
    // console.log(this.$route.path)
    // this.$Progress.start();
    this.$router.beforeEach((to, from, next) => {
      NProgress.start();
      next();
    });

    this.$router.afterEach(() => {
      NProgress.done();
    });
  },
  computed:{
    boxLayout(){
      if (this.$route.meta.layout === 'full'){
        return false;
      }
      return true
    }
  },
  head() {
    return {
      title: 'کلاسینو - اولین و بزرگترین آموزشگاه و کلاس آنلاین کنکور و پایه'
    }
  }
}
</script>

<style lang="scss" >
@import "../assets/sass/app.scss";
@import "../styles/main";
.vs-loading__load__text{
  font-size: 1em !important;
}
$font-family: IRANSansX;
$body-font-family : IRANSansX;
$heading-font-family : IRANSansX;


.v-application {
  [class*='text-'] {
    font-family: $font-family !important;
  }
  font-family: $font-family !important;
}

* {
  letter-spacing: 0!important;
}

.v-application {
  background-color: #fff!important;
}
</style>